// Role → allowed actions. Mirrors the Supabase RLS policies so the UI never
// offers something the database will reject.
const PERMISSIONS = {
  admin: '*',
  doctor: [
    'appointments.book', 'appointments.edit',
    'patients.edit',
    // clinical.view: prescriptions, visit notes, diagnoses, doctor notes (RLS: admin + doctor)
    'clinical.view', 'prescriptions.write', 'notes.write', 'photos.upload', 'photos.edit', 'feedback.add',
  ],
  receptionist: [
    'appointments.book', 'appointments.edit',
    'patients.add', 'patients.edit',
    'invoices.create', 'invoices.edit',
    'photos.upload',
    'attendance.mark', 'feedback.add',
  ],
}

// Menu sections a role must not see (RLS blocks their data for these roles)
const HIDDEN_TABS = {
  receptionist: ['reports', 'inventory', 'staff', 'feedback', 'settings', 'prescriptions'],
}

export function canSeeTab(role, tab) {
  return !(HIDDEN_TABS[role] || []).includes(tab)
}

export function can(role, action) {
  const p = PERMISSIONS[role]
  if (!p) return false
  return p === '*' || p.includes(action)
}

export const NO_ACCESS_MSG = "You don't have access to this."
export const PAST_BOOKING_MSG = 'Cannot book an appointment in the past. Choose a current or future time slot.'

// Turn Supabase / Postgres errors into something a receptionist can act on.
export function friendlyError(err, fallback = 'Something went wrong. Please try again.') {
  if (!err) return fallback
  const msg  = String(err.message || err || '')
  const code = err.code || ''
  if (/cannot book an appointment in the past/i.test(msg)) return PAST_BOOKING_MSG
  if (code === '42501' || /row-level security|permission denied/i.test(msg)) return NO_ACCESS_MSG
  if (code === '23505') {
    if (/staff/i.test(msg)) return 'Another staff member already uses this phone number or email.'
    return 'This record already exists.'
  }
  if (code === '23514' && /payment_status/i.test(msg)) return 'Invalid payment status.'
  return msg || fallback
}
